import React, { useState } from "react";
import { useForm } from "react-hook-form";

import DashboardLayout from "./components/Layout";
import { changePassword } from "../../api/authentication/register";

const ChangePasswordPage = () => {
  const [serverError, setServerError] = useState("");
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm();

  const newPassword = watch("newPassword");

  const onSubmit = async (formData) => {
    setServerError("");
    setSuccess(false);
    try {
      await changePassword(formData.currentPassword, formData.newPassword);
      setSuccess(true);
      reset();
    } catch (e) {
      setServerError(
        e?.response?.data?.message ||
          "Şifrə dəyişdirilmədi. Zəhmət olmasa, yenidən cəhd edin."
      );
    }
  };

  const inputClass =
    "mt-1 w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-black";

  return (
    <DashboardLayout>
      <div className="max-w-md mx-auto mt-10 bg-white p-8 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-6">🔒 Şifrəni dəyiş</h2>

        {success && (
          <div className="mb-4 bg-green-50 border border-green-200 text-green-700 text-sm rounded px-4 py-3">
            Şifrəniz uğurla dəyişdirildi.
          </div>
        )}
        {serverError && (
          <div className="mb-4 bg-red-50 border border-red-200 text-red-600 text-sm rounded px-4 py-3">
            {serverError}
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700">Cari şifrə</label>
            <input
              type="password"
              {...register("currentPassword", { required: true })}
              className={inputClass}
            />
            {errors.currentPassword && (
              <p className="mt-1 text-xs text-red-600">Cari şifrəni daxil edin.</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Yeni şifrə</label>
            <input
              type="password"
              {...register("newPassword", { required: true, minLength: 8 })}
              className={inputClass}
            />
            {errors.newPassword && (
              <p className="mt-1 text-xs text-red-600">Yeni şifrə ən azı 8 simvol olmalıdır.</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Yeni şifrə (təkrar)</label>
            <input
              type="password"
              {...register("confirmPassword", {
                required: true,
                validate: (value) => value === newPassword || "Şifrələr uyğun gəlmir.",
              })}
              className={inputClass}
            />
            {errors.confirmPassword && (
              <p className="mt-1 text-xs text-red-600">
                {errors.confirmPassword.message || "Şifrəni təkrar daxil edin."}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800 disabled:bg-gray-400"
          >
            {isSubmitting ? "Dəyişdirilir..." : "Şifrəni dəyiş"}
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default ChangePasswordPage;
